import { Directive, HostListener, Input, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import { Logger } from '../../_core/logger.service';
import { ConfigService } from '../../_core/service/config.service';
import { AnalyticsService } from './analytics.service';
import { RequestService } from '../../_services/request/request.service';
@Directive({
  selector: '[adobeAnalytics]',
  standalone: true,
})
export class AnalyticsDirective {
  @Input() adobeDataLayer: any;
  @Input() srcUrl = '';

  private previousUrl = '';
  private formViewUmSet = false;
  private formViewPipSet = false;
  private formStartUmSet = false;
  private formStartPipSet = false;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    private analyticsService: AnalyticsService,
    private requestService: RequestService,
  ) {}

  ngOnInit(): void {
    this.router.events.subscribe((evt: any) => {
      if (evt instanceof RoutesRecognized) {
        const routeData = evt.state.root.firstChild;
        if (routeData && routeData.data) {
          if (routeData.data['adobeDataLayer']) {
            Logger.log('Route Data:', routeData.data['adobeDataLayer']);

            // Preserve the original page name from route data before updating URLs
            const originalPageName =
              routeData.data['adobeDataLayer'].page?.pageName;

            routeData.data['adobeDataLayer'].page.URL =
              `${window.location.origin}${evt.urlAfterRedirects}`;
            routeData.data['adobeDataLayer'].page.fullURL =
              `${window.location.origin}${evt.urlAfterRedirects}`;
            routeData.data['adobeDataLayer'].page.previousURL =
              `${window.location.origin}${this.previousUrl}`;

            // Get accurate step based on URL and page name
            const currentStep = this.analyticsService.getStepFromUrl(
              routeData.data['adobeDataLayer'].page.URL,
              originalPageName,
            );
            routeData.data['adobeDataLayer'].event = 'pageView';
            this.analyticsService.setAdobeDataLayer(
              routeData.data['adobeDataLayer'],
              currentStep,
            );
          }
        }
        this.loopAdobeDataLayer(routeData, evt);
        this.previousUrl = evt.urlAfterRedirects;
      }
    });
  }

  // looping throught child routes and update adobeDataLayer using "data" attribute passed in routes from application.
  loopAdobeDataLayer(routeData: any, evt: any) {
    if (routeData.children && routeData.children.length) {
      routeData.children.forEach((child: any) => {
        if (child.data.adobeDataLayer) {
          // Preserve the original page name from route data before updating URLs
          const originalPageName = child.data['adobeDataLayer'].page?.pageName;

          child.data['adobeDataLayer'].page.URL =
            `${window.location.origin}${evt.urlAfterRedirects}`;
          child.data['adobeDataLayer'].page.fullURL =
            `${window.location.origin}${evt.urlAfterRedirects}`;
          child.data['adobeDataLayer'].page.previousURL =
            `${window.location.origin}${this.previousUrl}`;

          // Get accurate step based on URL and page name
          const currentStep = this.analyticsService.getStepFromUrl(
            child.data['adobeDataLayer'].page.URL,
            originalPageName,
          );

          if (
            child.data['adobeDataLayer'].page.URL.includes('uimui-consent') &&
            this.requestService
              .getStepForFormType('um_uim')
              ?.includes('Not Started') &&
            !this.formViewUmSet
          ) {
            child.data['adobeDataLayer'].event = 'formView';
            this.formViewUmSet = true;
            this.analyticsService.setAdobeDataLayer(
              child.data.adobeDataLayer,
              currentStep,
            );
          } else if (
            child.data['adobeDataLayer'].page.URL.includes('pip-consent') &&
            this.requestService
              .getStepForFormType('pip')
              ?.includes('Not Started') &&
            !this.formViewPipSet
          ) {
            child.data['adobeDataLayer'].event = 'formView';
            this.formViewPipSet = true;
            this.analyticsService.setAdobeDataLayer(
              child.data.adobeDataLayer,
              currentStep,
            );
          }
          child.data['adobeDataLayer'].event = 'pageView';
          this.analyticsService.setAdobeDataLayer(
            child.data.adobeDataLayer,
            currentStep,
          );
        }
        !child?.data?.adobeDataLayer?.config?.isNoChild &&
          this.loopAdobeDataLayer(child, evt);
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes &&
      changes['adobeDataLayer'] &&
      changes['adobeDataLayer'].currentValue
    ) {
      this.analyticsService.adobeDataLayer =
        this.analyticsService.overrideAndAddKeys(
          this.adobeDataLayer,
          changes['adobeDataLayer'].currentValue,
        );
    }
    if (changes && changes['srcUrl'] && changes['srcUrl'].currentValue) {
      const scriptUrl = changes['srcUrl'].currentValue;

      // Check if script is already present in document.head
      if (!document.querySelector(`script[src="${scriptUrl}"]`)) {
        Logger.log('Script not found, adding analytics script:', scriptUrl);
        const node = document.createElement('script');
        node.src = scriptUrl;
        node.async = true;
        document.head.appendChild(node);
      }
    }
  }

  @HostListener('document:click', ['$event'])
  siteInteractionClick(event: any) {
    // this.analyticsService.setAdobeDataLayerMapEvent(event, this.isLoggedIn);
  }
}
